import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ValidatorHelper {

  formGroup: FormGroup;
  submitted = false;
  errorReq = false;
  errorMessage = undefined;
  errorLoaded = false;

  isInvalid(field: string) {
    return this.submitted && this.formGroup.get(field).errors ? this.formGroup.get(field).errors : undefined;
  }

  isRequired(field: string) {
    return this.isInvalid(field).required;
  }

  isEmpty(campo) {
    if (campo == null || campo == '' || campo == undefined) {
      return true;
    }
    return false;
  }

  error(ex: HttpErrorResponse) {
    if (ex.status == undefined || ex.status == 403) {
      this.errorMessage = "Acesso negado";
    } else if (ex.status == 401) {
      this.errorMessage = "Usuário ou senha inválidos";
    } else {
      this.errorMessage = "Ocorreu um erro interno";
    }
  }
  validaCheck(valor) {
    if (valor === true) {
      return 1
    }
    else {
      return 0;
    }

  }
}